<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import YzlLogin from "@/config/utils/yzlLogin?t=123";
import moment from "moment/moment";

export default {
  name: "App",
  data() {
    return {};
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        console.log('app watch this.$route => ', this.$route);
        const code = this.$route.query.code;
        const state = this.$route.query.state;
        if (code && state) {
          console.log("$route state", state);
          console.log("$route code", code);
          YzlLogin(code, state, this);
        }
      }
    }
  },
  components: {},
  beforeCreate() {
    // 缓存读取
    const localLoginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    if (
        localLoginInfo &&
        localLoginInfo.version === moment(Date.now()).format("YYYY-MM-DD")
    ) {
      console.log("localLoginInfo => ", localLoginInfo);
      this.$store.commit("auth/setLoginInfo", {
        ...localLoginInfo.data,
      });
    } else {
      console.log("localLoginInfo => empty",);
      this.$store.commit("auth/setLoginOut", {});
    }

    // 环境检测（发布时必须改为pro）
    this.$store.commit("host/setEnv", {
      env: "pro"
    });

    // 开发环境假数据
    if (this.$store.state.host.env == 'dev') {
      this.$store.commit("auth/setLoginInfo", {
        token: "3eded7e7-a79e-4c21-add2-5e39596b20f9",
        user_id: 20,
        nickname: "开发者0703",
      });
    }
    console.log(
        `App.vue;${this.$store.state.host.env};v${this.$store.state.version};`
    );
  },
  async mounted() {
  },
  methods: {},
};
</script>

<style>
body {
  margin: 0;
  overflow: auto;
  /* 显示滚动条 */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p {
  margin: 0;
}

.disable {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  /* 冲突，此句并不会产生效果 */
}

.noData {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > img {
    width: 60px;
  }

  > span {
    font-size: 12px;
    color: #999;
  }
}

.indexView {
  width: 100%;
  background: #e7e9f2;

  .el-container {
    width: 100%;

    .el-main {
      padding: 60px 0 0;
      width: 100%;
      min-width: 1280px;
      background: #fff;
      //background: #f1f1f1;

      .breadcrumb {
        margin: 20px auto;
        padding: 0 10px;
        width: 1260px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .backItem {
          margin-right: 10px;
          padding-right: 4px;
          width: 52px;
          height: 24px;
          border: 1px solid #666;
          border-radius: 14px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }

        .el-breadcrumb {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
}
</style>